import { type FC } from 'react';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { useCreateOpAgentPackageLinkMutation } from '@features/integrations/api/create-agent.api';

import { cleanAgentDescription, handleAgentSubmissionError, STEP } from '../../create-agent.utils';
import type { BaseAgentDetailsProps } from '../../create-agent.utils';
import { opAgentDetailsSchema, OP_AGENT_DETAILS_DEFAULTS } from '../general/generic-agent-details.schema';
import type { OpAgentDetailsFormValues } from '../general/generic-agent-details.schema';
import { GenericAgentDetailsForm } from '../general/GenericAgentDetails.form';

export const OpAgentDetails: FC<BaseAgentDetailsProps> = ({ onGenerateSuccess, onClose }) => {
  const [createOpAgentPackageLink, { isLoading, reset }] = useCreateOpAgentPackageLinkMutation();

  const form = useForm<OpAgentDetailsFormValues>({
    resolver: zodResolver(opAgentDetailsSchema),
    defaultValues: OP_AGENT_DETAILS_DEFAULTS,
  });

  const onGeneratePackageLink = async (data: OpAgentDetailsFormValues) => {
    try {
      const opAgentPayload = {
        name: data.name,
        agentHost: data.agentHost,
        ...cleanAgentDescription(data.description),
      };

      const response = await createOpAgentPackageLink(opAgentPayload).unwrap();

      onGenerateSuccess(response, opAgentPayload, STEP.OP_AGENT_GENERATE_BUNDLE);
    } catch (error) {
      handleAgentSubmissionError(error, (msg) => form.setError('name', { type: 'server', message: msg }));
    }
  };

  const handleCloseModal = () => {
    reset();
    onClose();
  };

  return (
    <GenericAgentDetailsForm
      form={form}
      onGeneratePackageLink={onGeneratePackageLink}
      isLoading={isLoading}
      onClose={handleCloseModal}
    />
  );
};
